module.exports = __webpack_public_path__ + "img/dashboard_student.807bec15.png";